'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WSGSP]');

var winresServiceGroupSelectPassengersController = function () {
    function winresServiceGroupSelectPassengersController($scope) {
        _classCallCheck(this, winresServiceGroupSelectPassengersController);

        this.$scope = $scope;
    }

    _createClass(winresServiceGroupSelectPassengersController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Mappings from passenger IDs to lists of service IDs.
            // Example: { 42: ['STH-ZOO', 'STH-MUS'], 53: ['STH-ZOO'] }
            this.values = {};

            // A helper structure in a form that's easier to use in the template.
            // Contains data from services and passengers in a single package.
            this.contents = [];

            this.ngModelCtrl.$render = function () {
                return _this.render(_this.ngModelCtrl.$viewValue);
            };
            this.ngModelCtrl.$isEmpty = function (value) {
                return _.toArray(value).length === 0;
            };

            this.ngModelCtrl.$validators.capacity = function (modelValue, viewValue) {
                return _.every(_this.services, function (service) {
                    if (service.capacity === undefined) {
                        return true;
                    }
                    var sid = _.toString(service.id);
                    var taken = _this.countPassengersWithService(sid);
                    return taken <= service.capacity;
                });
            };

            this.ngModelCtrl.$validators.forced = function (modelValue, viewValue) {
                // Skip this validation if this group is not forced
                if (_this.realMin() === 0) {
                    return true;
                }

                // Skip this validation if value is empty
                if (_this.ngModelCtrl.$isEmpty(modelValue)) {
                    return true;
                }

                // The keys of this hash correspond to passengers with at least one service
                var hash = _.keyBy(modelValue, function (m) {
                    return m[1];
                });

                // Check that every passenger with available services has chosen at least one
                return _.every(_this.passengers, function (p) {
                    return _.isEmpty(p.prices) || hash[p.id];
                });
            };

            this.$scope.$watchCollection(function () {
                return _this.services;
            }, function () {
                return _this.update();
            });
            this.$scope.$watchCollection(function () {
                return _this.passengers;
            }, function () {
                return _this.update();
            });

            // this.$scope.$watch(() => this.form.$dirty, () => {
            //     if (this.form.$dirty) {
            //         // The form was set to dirty. Let's see if it really should be.

            //         // Our version of AngularJS doesn't support $getControls.
            //         const controls = _.map(this.contents, (x, i) => this.form['services_' + i]);

            //         console.log(this.ngModelCtrl);

            //         if (_.some(controls, control => control.$pristine)) {
            //             log('At least one control is still pristine.');
            //             this.form.$setPristine();
            //             this.ngModelCtrl.$setPristine();
            //         }
            //     }
            // });
        }
    }, {
        key: 'setErrorState',
        value: function setErrorState() {
            this.values = {};
            this.read();
        }
    }, {
        key: 'update',
        value: function update() {
            var _this2 = this;

            log('Update:', this.services, this.passengers);

            if (!_.isArrayLike(this.services)) {
                // Invalid service list, remove all selections
                log.warn('Invalid service list:', this.services);
                this.setErrorState();
                return;
            }

            if (!_.isArrayLike(this.passengers)) {
                // Invalid passenger list, remove all selections
                log.warn('Invalid passenger list:', this.passengers);
                this.setErrorState();
                return;
            }

            // IDs of old and new services
            var oldSIDs = _.uniq(_.flatMap(this.values));
            var sids = this.serviceIDs();

            // IDs of added and removed services
            var addedSIDs = _.difference(sids, oldSIDs);
            var removedSIDs = _.difference(oldSIDs, sids);

            if (addedSIDs.length > 0) {
                log('Added', addedSIDs.length, 'services:', addedSIDs);
            }
            if (removedSIDs.length > 0) {
                log('Removed', removedSIDs.length, 'services:', removedSIDs);
            }

            // IDs of old and new passengers
            var oldPIDs = _.keys(this.values);
            var pids = this.passengerIDs();

            // IDs of added and removed passengers
            var addedPIDs = _.difference(pids, oldPIDs);
            var removedPIDs = _.difference(oldPIDs, pids);

            if (addedPIDs.length > 0) {
                log('Added', addedPIDs.length, 'passengers:', addedPIDs);
            }
            if (removedPIDs.length > 0) {
                log('Removed', removedPIDs.length, 'passengers:', removedPIDs);
            }

            // Add records for added passengers
            _.forEach(addedPIDs, function (pid) {
                _this2.values[pid] = [];
            });

            // Remove records of removed passengers
            _.forEach(removedPIDs, function (pid) {
                delete _this2.values[pid];
            });

            // Remove records of removed services from all passengers
            _.forEach(this.values, function (services) {
                _.pullAll(services, removedSIDs);
            });

            this.updateContents();

            // If services or passengers were removed, some currenct selections
            // may no longer be valid. That will affect the output.
            // In that case, the output needs to be regenerated.
            if (removedSIDs.length > 0 || removedPIDs.length > 0) {
                this.read();
            }
        }

        // Update the helper structure used in the template.
        // NOTE: This updates the entire structure. If that causes unnecessary
        // watches to fire somewhere down the stack, then this can be changed to
        // only change the relevant parts (as is done above for this.values).

    }, {
        key: 'updateContents',
        value: function updateContents() {
            var _this3 = this;

            this.contents = _.map(this.passengers, function (passenger) {
                var services = _.map(passenger.prices, function (price, serviceID) {
                    var service = _.find(_this3.services, function (s) {
                        return s.id == serviceID;
                    });
                    if (service) {
                        return {
                            id: service.id,
                            name: service.name,
                            priceLabel: price.priceLabel,
                            price: price.price,
                            capacity: _this3.effectiveCapacity(passenger, service)
                        };
                    } else {
                        log.warn('Unknown service ID:', serviceID);
                        return null;
                    }
                });

                return {
                    passenger: passenger,
                    services: _.filter(services) // Remove possible nulls introduced above
                };
            });
        }
    }, {
        key: 'render',
        value: function render(value) {
            // log('Input:', value);

            if (!_.isArrayLike(value)) {
                log.warn('Provided model value is invalid:', value);
                value = [];
            }

            var hash = {};
            _.forEach(value, function (m) {
                var sid = m[0];
                var pid = m[1];
                if (!hash.hasOwnProperty(pid)) {
                    hash[pid] = {};
                }
                hash[pid][sid] = 1;
            });

            // Make sure to only include IDs that exist in services and passengers lists.
            hash = _.pick(hash, this.passengerIDs());
            var serviceIDs = this.serviceIDs();
            hash = _.mapValues(hash, function (services) {
                return _.pick(services, serviceIDs);
            });

            this.values = hash;
        }
    }, {
        key: 'read',
        value: function read() {
            var _this4 = this;

            var passengerIDs = this.passengerIDs();
            var mappings = _.flatMap(this.serviceIDs(), function (sid) {
                var pids = _.filter(passengerIDs, function (pid) {
                    return _this4.passengerHasService(pid, sid);
                });
                return _.map(pids, function (pid) {
                    return [sid, pid];
                });
            });
            log('Output:', mappings);
            this.ngModelCtrl.$setViewValue(mappings);
            this.updateContents();
        }
    }, {
        key: 'serviceIDs',
        value: function serviceIDs() {
            return _.map(this.services, function (s) {
                return _.toString(s.id);
            });
        }
    }, {
        key: 'passengerIDs',
        value: function passengerIDs() {
            return _.map(this.passengers, function (p) {
                return _.toString(p.id);
            });
        }
    }, {
        key: 'passengerHasService',
        value: function passengerHasService(passengerID, serviceID) {
            return this.values && this.values[passengerID] && this.values[passengerID][serviceID] > 0;
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            return this.disabled !== undefined && this.disabled !== false;
        }
    }, {
        key: 'isRequired',
        value: function isRequired() {
            return this.required !== undefined && this.required !== false;
        }
    }, {
        key: 'isSingle',
        value: function isSingle() {
            return this.realMin() == 1 && this.max == 1;
        }
    }, {
        key: 'realMin',
        value: function realMin() {
            if (this.min > 0) {
                return this.min;
            } else if (this.isRequired()) {
                return 1;
            } else {
                return 0;
            }
        }

        // Return the effective capacity for this passenger-service combination.
        // This needs to be reduced if other passengers have picked the service
        // as well.

    }, {
        key: 'effectiveCapacity',
        value: function effectiveCapacity(passenger, service) {
            if (service.capacity > 0) {
                // Total amount of passengers who have selected this service
                var total = this.countPassengersWithService(service.id);
                var ownTotal = this.passengerHasService(passenger.id, service.id) ? 1 : 0;
                var othersTotal = total - ownTotal;
                var left = service.capacity - othersTotal;
                return Math.max(0, left);
            } else {
                // No limit
                return undefined;
            }
        }
    }, {
        key: 'countPassengersWithService',
        value: function countPassengersWithService(serviceID) {
            var _this5 = this;

            var pids = this.passengerIDs();
            var count = _.countBy(pids, function (passengerID) {
                return _this5.passengerHasService(passengerID, serviceID);
            });
            return count.true || 0;
        }
    }, {
        key: 'totalPrice',
        value: function totalPrice() {
            var _this6 = this;

            var sum = 0;
            _.forEach(this.passengers, function (passenger) {
                _.forEach(passenger.prices, function (price, priceID) {
                    if (_this6.passengerHasService(passenger.id, priceID)) {
                        sum += price.price;
                    }
                });
            });
            return sum;
        }
    }]);

    return winresServiceGroupSelectPassengersController;
}();

winresServiceGroupSelectPassengersController.$inject = ['$scope'];

_module3.default.component('winresServiceGroupSelectPassengers', {
    template: require('./winresServiceGroupSelectPassengers.html'),
    controller: winresServiceGroupSelectPassengersController,
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        // List of services. NOTE: The id field is meant to be unique to each
        // services. It is used to detect when a service is added or removed,
        // so that the service's selections can also be removed.
        // [
        //     {
        //         id: 'STH-ZOO'
        //         name: 'Stockholm Zoo',
        //         capacity: 99
        //     },
        //     {
        //         id: 'STH-MUS',
        //         name: 'Stockholm Museum',
        //         capacity: 20
        //     }
        // ]
        services: '<',

        // List of passengers. NOTE: The id field is meant to be unique to each
        // passenger. It is used to detect when a passenger is added or removed,
        // so that the passenger's selections can also be removed.
        // The prices field contains the price for the service for that passenger.
        // If a service is not available for the passenger, the service is omitted.
        // [
        //     {
        //         id: 42
        //         name: 'John Smith',
        //         prices: {
        //             'STH-ZOO': { priceLabel: 'adult', price: 50 },
        //             'STH-MUS': { priceLabel: 'adult', price: 29 }
        //         }
        //     },
        //     {
        //         id: 56,
        //         name: 'Mary Smith',
        //         prices: {
        //             'STH-ZOO': { priceLabel: 'child', price: 25 }
        //         }
        //     }
        // ]
        passengers: '<',

        // List of selected service-passenger combinations.
        // [ ['STH-ZOO', 42], ['STH-ZOO', 53], ['STH-MUS', 42] ]
        ngModel: '<',

        // If this attribute is set (to anything), the component is disabled.
        disabled: '@',

        // If this attribute is set (to anything), a non-empty value is required.
        required: '@',

        // Each passenger must select at least this many services.
        min: '<',

        // Each passenger must select at most this many services.
        max: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceGroupSelectPassengers/winresServiceGroupSelectPassengers.js
// module id = 457
// module chunks = 2